import { render, staticRenderFns } from "./TreeComp.vue?vue&type=template&id=ccd8e984"
import script from "./TreeComp.vue?vue&type=script&lang=js"
export * from "./TreeComp.vue?vue&type=script&lang=js"
import style0 from "./TreeComp.vue?vue&type=style&index=0&id=ccd8e984&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports